import tuitionInvoiceService from '../../services/tuitionInvoice.service';

export const tuitionInvoiceConstants = {
  GETALL_REQUEST: 'TUITION_INVOICE_GETALL_REQUEST',
  GETALL_SUCCESS: 'TUITION_INVOICE_GETALL_SUCCESS',
  GETALL_FAILURE: 'TUITION_INVOICE_GETALL_FAILURE',

  GETBYID_REQUEST: 'TUITION_INVOICE_GETBYID_REQUEST',
  GETBYID_SUCCESS: 'TUITION_INVOICE_GETBYID_SUCCESS',
  GETBYID_FAILURE: 'TUITION_INVOICE_GETBYID_FAILURE',

  GET_BY_TUITION_DETAIL_REQUEST: 'TUITION_INVOICE_GET_BY_TUITION_DETAIL_REQUEST',
  GET_BY_TUITION_DETAIL_SUCCESS: 'TUITION_INVOICE_GET_BY_TUITION_DETAIL_SUCCESS',
  GET_BY_TUITION_DETAIL_FAILURE: 'TUITION_INVOICE_GET_BY_TUITION_DETAIL_FAILURE',

  CREATE_REQUEST: 'TUITION_INVOICE_CREATE_REQUEST',
  CREATE_SUCCESS: 'TUITION_INVOICE_CREATE_SUCCESS',
  CREATE_FAILURE: 'TUITION_INVOICE_CREATE_FAILURE',

  UPDATE_REQUEST: 'TUITION_INVOICE_UPDATE_REQUEST',
  UPDATE_SUCCESS: 'TUITION_INVOICE_UPDATE_SUCCESS',
  UPDATE_FAILURE: 'TUITION_INVOICE_UPDATE_FAILURE',

  DELETE_REQUEST: 'TUITION_INVOICE_DELETE_REQUEST',
  DELETE_SUCCESS: 'TUITION_INVOICE_DELETE_SUCCESS',
  DELETE_FAILURE: 'TUITION_INVOICE_DELETE_FAILURE',

  GET_STATISTICS_REQUEST: 'TUITION_INVOICE_GET_STATISTICS_REQUEST',
  GET_STATISTICS_SUCCESS: 'TUITION_INVOICE_GET_STATISTICS_SUCCESS',
  GET_STATISTICS_FAILURE: 'TUITION_INVOICE_GET_STATISTICS_FAILURE',

  UPLOAD_IMAGE_REQUEST: 'TUITION_INVOICE_UPLOAD_IMAGE_REQUEST',
  UPLOAD_IMAGE_SUCCESS: 'TUITION_INVOICE_UPLOAD_IMAGE_SUCCESS',
  UPLOAD_IMAGE_FAILURE: 'TUITION_INVOICE_UPLOAD_IMAGE_FAILURE',
};

export const tuitionInvoiceActions = {
  getAll,
  getById,
  getByTuitionDetailId,
  create,
  update,
  deleteInvoice,
  getStatistics,
  uploadTransferImage,
};

function getAll(filters?: any) {
  return (dispatch: any) => {
    dispatch(request());

    tuitionInvoiceService.getAll(filters)
      .then(
        (response) => dispatch(success(response.data)),
        (error) => dispatch(failure(error.toString()))
      );
  };

  function request() {
    return { type: tuitionInvoiceConstants.GETALL_REQUEST };
  }
  function success(data: any) {
    return { type: tuitionInvoiceConstants.GETALL_SUCCESS, data };
  }
  function failure(error: any) {
    return { type: tuitionInvoiceConstants.GETALL_FAILURE, error };
  }
}

function getById(id: number) {
  return (dispatch: any) => {
    dispatch(request());

    tuitionInvoiceService.getById(id)
      .then(
        (response) => dispatch(success(response.data)),
        (error) => dispatch(failure(error.toString()))
      );
  };

  function request() {
    return { type: tuitionInvoiceConstants.GETBYID_REQUEST };
  }
  function success(data: any) {
    return { type: tuitionInvoiceConstants.GETBYID_SUCCESS, data };
  }
  function failure(error: any) {
    return { type: tuitionInvoiceConstants.GETBYID_FAILURE, error };
  }
}

function getByTuitionDetailId(tuitionDetailId: number) {
  return (dispatch: any) => {
    dispatch(request());

    return tuitionInvoiceService.getByTuitionDetailId(tuitionDetailId)
      .then(
        (response) => {
          dispatch(success(response.data));
          return response;
        },
        (error) => {
          dispatch(failure(error.toString()));
          return Promise.reject(error);
        }
      );
  };

  function request() {
    return { type: tuitionInvoiceConstants.GET_BY_TUITION_DETAIL_REQUEST };
  }
  function success(data: any) {
    return { type: tuitionInvoiceConstants.GET_BY_TUITION_DETAIL_SUCCESS, data };
  }
  function failure(error: any) {
    return { type: tuitionInvoiceConstants.GET_BY_TUITION_DETAIL_FAILURE, error };
  }
}

function create(invoice: any) {
  return (dispatch: any) => {
    dispatch(request());

    return tuitionInvoiceService.create(invoice)
      .then(
        (response) => {
          dispatch(success(response.data));
          return response;
        },
        (error) => {
          dispatch(failure(error.toString()));
          throw error;
        }
      );
  };

  function request() {
    return { type: tuitionInvoiceConstants.CREATE_REQUEST };
  }
  function success(data: any) {
    return { type: tuitionInvoiceConstants.CREATE_SUCCESS, data };
  }
  function failure(error: any) {
    return { type: tuitionInvoiceConstants.CREATE_FAILURE, error };
  }
}

function update(id: number, invoice: any) {
  return (dispatch: any) => {
    dispatch(request());

    return tuitionInvoiceService.update(id, invoice)
      .then(
        (response) => {
          dispatch(success(response.data));
          return response;
        },
        (error) => {
          dispatch(failure(error.toString()));
          throw error;
        }
      );
  };

  function request() {
    return { type: tuitionInvoiceConstants.UPDATE_REQUEST };
  }
  function success(data: any) {
    return { type: tuitionInvoiceConstants.UPDATE_SUCCESS, data };
  }
  function failure(error: any) {
    return { type: tuitionInvoiceConstants.UPDATE_FAILURE, error };
  }
}

function deleteInvoice(id: number) {
  return (dispatch: any) => {
    dispatch(request());

    return tuitionInvoiceService.delete(id)
      .then(
        () => {
          dispatch(success(id));
          return id;
        },
        (error) => {
          dispatch(failure(error.toString()));
          throw error;
        }
      );
  };

  function request() {
    return { type: tuitionInvoiceConstants.DELETE_REQUEST };
  }
  function success(id: number) {
    return { type: tuitionInvoiceConstants.DELETE_SUCCESS, id };
  }
  function failure(error: any) {
    return { type: tuitionInvoiceConstants.DELETE_FAILURE, error };
  }
}

function getStatistics(month: number, year: number) {
  return (dispatch: any) => {
    dispatch(request());

    tuitionInvoiceService.getStatistics(month, year)
      .then(
        (response) => dispatch(success(response.data)),
        (error) => dispatch(failure(error.toString()))
      );
  };

  function request() {
    return { type: tuitionInvoiceConstants.GET_STATISTICS_REQUEST };
  }
  function success(data: any) {
    return { type: tuitionInvoiceConstants.GET_STATISTICS_SUCCESS, data };
  }
  function failure(error: any) {
    return { type: tuitionInvoiceConstants.GET_STATISTICS_FAILURE, error };
  }
}

function uploadTransferImage(file: File) {
  return (dispatch: any) => {
    dispatch(request());

    return tuitionInvoiceService.uploadTransferImage(file)
      .then(
        (response) => {
          dispatch(success(response.data));
          return response;
        },
        (error) => {
          dispatch(failure(error.toString()));
          throw error;
        }
      );
  };

  function request() {
    return { type: tuitionInvoiceConstants.UPLOAD_IMAGE_REQUEST };
  }
  function success(data: any) {
    return { type: tuitionInvoiceConstants.UPLOAD_IMAGE_SUCCESS, data };
  }
  function failure(error: any) {
    return { type: tuitionInvoiceConstants.UPLOAD_IMAGE_FAILURE, error };
  }
}
